<template>
	<div class="wrapper">
		<div class="section section-blogs-2 topsearch">
			<div class="container main">
				<div class="md-layout">
					<div class="md-layout-item md-size-100 md-small-size-100 mx-auto">
						<router-link :to="{ name: 'territorie', params: {dictionaryId: dictCode, page: page} }"
									 id="buttonback">
							<md-icon>keyboard_arrow_left</md-icon>
							Назад к списку Территорий
						</router-link>
					</div>
					<div class="md-layout-item md-size-100 md-small-size-100 mx-auto">

						<div class="name">
							<h3 class="title">Редактирование элемента справочника Территорий представительств</h3>
							<div class="md-layout-item md-size-100 md-xsmall-size-100 fieldsep" v-if="selectedDataId">
								<div class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep">
									<md-autocomplete :class="getValidationClass('city')"
													 :md-options="cities"
													 @md-changed="setCities"
													 @md-opened="setCities"
													 @md-selected="setCity"
													 v-model="form['city']"
									>
										<label>{{mapElementName['city']}}</label>
										<span class="md-error"
											  v-if="!$v.form.city.required">Обязательно для заполнения</span>
									</md-autocomplete>
								</div>
								<div class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep">
									<md-field>
										<label>{{mapElementName['country']}}</label>
										<md-input readonly type="text" v-model="form['country']"/>
									</md-field>
								</div>
								<div class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep">
									<md-field>
										<label>{{ mapElementName['region'] }}</label>
										<md-select v-model="form['rehOfficeId']"
												   md-dense
												   name="rehOffice"
												   @md-selected="changeSelOffce()"
										>
											<md-option v-for="item of officeData" :value="item.id">{{item.name}}</md-option>
										</md-select>
									</md-field>
								</div>
								<div class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep">
									<md-field>
										<label>{{mapElementName['countryCode']}}</label>
										<md-input readonly type="text" v-model="form['countryCode']"/>
									</md-field>
								</div>
								<div class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep">
									<md-field>
										<label>{{mapElementName['fedSub']}}</label>
										<md-input readonly type="text" v-model="form['fedSub']"/>
									</md-field>
								</div>
								<div class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep">
									<md-field>
										<label>{{mapElementName['fedSubCode']}}</label>
										<md-input readonly type="text" v-model="form['fedSubCode']"/>
									</md-field>
								</div>
								<div class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep">
									<md-field>
										<label>{{mapElementName['cityCode']}}</label>
										<md-input readonly type="text" v-model="form['cityCode']"/>
									</md-field>
								</div>

							</div>
							<br/>
							<div class="md-layout-item md-gutter md-size-100 md-xsmall-size-100 fieldsep">

								<template v-if="selectedDataId">
									<md-button @click="validateData(saveItem)"
											   class="md-button md-success md-theme-default"
											   v-if="action !== 'delete'">
										Сохранить
									</md-button>

									<md-button @click="validateData(deleteItem)"
											   class="md-button md-primary  md-theme-default"
											   v-if="action === 'delete'">
										Удалить
									</md-button>

								</template>
							</div>
						</div>


					</div>
				</div>

			</div>
		</div>
	</div>
</template>
<script>
    import { validationMixin } from 'vuelidate'
    import { checkAuthentication, reAuthenticate } from '@/utils/auth-api'
    import {
        required,
    } from 'vuelidate/lib/validators'
    import { saveItem, getItem, deleteItem, saveNewItem, deleteNewItem } from '@/utils/dict-api'
	import {appConfig} from '../../utils/config-api'

    export default {
        mixins: [
            validationMixin,
        ],
        bodyClass: 'dictionary-data',
        props: ['page', 'action'],
        data () {
            return {
				officeData: null,
                options: [],
                dictCode: this.$route.params.dictCode,
                dictionaryId: '',
                selectedDataId: this.$route.params.id,
                selectedData: null,
                form: {
					id: this.$route.params.id,
					action: 'save',
					country: '',
					countryCode: '',
					fedSub: '',
					fedSubCode: '',
                    city: '',
                    cityCode: '',
					rehOffice: {},
					rehOfficeId: 0,
                },
                mapElementName: {
                	region: 'Выберите представительство',
                    locOrder: 'Порядок отображения',
                    city: 'Населенный пункт',
                    phone: 'Телефон',
                    country: 'Страна',
                    countryCode: 'Код страны',
                    fedSub: 'Федеральный субъект',
                    fedSubCode: 'Код фед субъекта',
                    cityCode: 'Код населенного пункта',
                },
                cities: [],
                citiesObj: [],
            }
        },
        validations: {
            form: {
				rehOffice:{
					required,
				},
				id: {
					required,
				},
				country: {
					required,
				},
				countryCode: {
					required,
				},
				fedSub: {
					required,
				},
				fedSubCode: {
					required,
				},
				city: {
					required,
				},
				cityCode: {
					required,
				},
            },
        },
        methods: {
            setCities () {
                if (this.form.city.length > 1) {
                    fetch(`${appConfig.backendUrl}/rest/geo/getcitybyname?cityName=${this.form.city}`)
                      .then(response => {
                          return response.json()
                      })
                      .then(responseJson => {
                          this.citiesObj = responseJson
                          this.cities = []
                          responseJson.forEach(item => {
                              this.cities.push(item.city)
                          })
                      })
                } else {
                    return []
                }
            },
            setCity (city) {
                let cityData = this.citiesObj.find(item => item.city === city)
                this.form.country = cityData.country
                this.form.countryCode = cityData.countryCode
                this.form.fedSub = cityData.fedSub
                this.form.fedSubCode = cityData.fedSubCode
                this.form.cityCode = cityData.cityCode
            },
            getValidationClass (fieldName) {
                const field = this.$v.form[fieldName]
                if (field) {
                    return {
                        'md-invalid': field.$invalid && field.$dirty,
                    }
                }
            },
            validateData (sendFn) {
                this.$v.form.$touch()
                if (!this.$v.form.$invalid) {
                    sendFn()
                } else {
                	console.log("Form invalid");
                	console.log(this.$v.form);
				}
            },
			changeSelOffce() {
            	for (let item in this.officeData) {
            		if (this.officeData[item].id == this.form.rehOfficeId) {
            			this.form.rehOffice = this.officeData[item];
					}
				}
			},
            setData: function (data) {
                this.form = data;
                this.form.rehOfficeId = this.form.rehOffice.id;
            },
            getElementData: function () {
                if (this.selectedDataId === 'new') {
                    this.addItem()
                    return
                }
                checkAuthentication(this.$router, this.$route).then(response => {
                    getItem('territorie', this.selectedDataId).then(result => {
                        this.setData(result)
                    }).catch(error => {
                        reAuthenticate(this.$router, this.$route, error)
                    })
                })
            },
            addItem: function () {
                const item = {
					rehOffice: {},
					rehOfficeId: 0,
					id: this.$route.params.id,
					country: '',
					countryCode: '',
					fedSub: '',
					fedSubCode: '',
					city: '',
					cityCode: '',
                }
                this.setData(item)
            },
            saveItem: function () {
                if (this.form.id === 'new') {
                    this.form.id = null
                }
                checkAuthentication(this.$router, this.$route).then(response => {
                    saveNewItem('territorie', JSON.stringify(this.form)).then(result => {
                        this.$router.push({ name: 'territorie' })
                    }).catch(error => {
                        reAuthenticate(this.$router, this.$route, error)
                    })
                })
            },
            deleteItem: function () {
                checkAuthentication(this.$router, this.$route).then(response => {
                    deleteNewItem('territorie', JSON.stringify(this.form)).then(result => {
                        this.$router.push({ name: 'territorie' })
                    }).catch(error => {
                        reAuthenticate(this.$router, this.$route, error)
                    })
                })
            },
            checkEditableNames: function (name) {
                const editableNames = ['valueId', 'value', 'order']
                return (editableNames.indexOf(name) >= 0)
            },
			getLocation () {
				checkAuthentication(this.$router, this.$route).then(response => {
					getItem('office').then(result => {
						this.officeData = result
					}).catch(error => {
						reAuthenticate(this.$router, this.$route, error)
					})
				})
			},
        },
        created () {
            if (this.$route.params.action === 'delete') {
                this.deleteItem()
            } else {
                this.getElementData()
                this.getLocation()
            }
        },
    }
</script>

<style lang="scss" scoped type="text/scss">
	.dictionary-data .md-field {
		padding-top: 16px;
		margin: 4px 0 24px;
	}

	.offset-left-16 {
		margin-left: 16px;
	}
</style>
